import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { AuthProvider } from "./contexts/AuthContext";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import { MaintenanceProvider } from "./contexts/MaintenanceContext";
import { TaskListProvider } from "./contexts/TaskListContext";
import AppRoutes from "./routes";
import "./shared/styles/theme.css";

import { requestForToken, onMessageListener } from "./Firebase";
import NotificationSnackbar from "./components/NotificationModal";
import CustomDropdown from './shared/components/Customdropdown';

const App = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const requestNotificationPermission = async () => {
      if ('Notification' in window && Notification.permission === 'default') {
        await Notification.requestPermission();
      }
    };

    requestNotificationPermission();
    
    // Request FCM token and log it
    requestForToken().then(token => {
      if (token) {
        console.log("=== APP INITIALIZATION LOGS ===");
        console.log("FCM Token obtained:", token);
        console.log("=================================");
      }
    }).catch(error => {
      console.warn('Failed to get FCM token:', error);
    });
    
    const unsubscribe = onMessageListener((payload) => {
      const message = payload?.notification?.body || "New notification received";
      setSnackbarMessage(message);
      setSnackbarOpen(true);
    });

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <Router>
      <AuthProvider>
        <SnackbarProvider>
          <MaintenanceProvider>
            <TaskListProvider>
              <AppRoutes />

            <NotificationSnackbar
              open={snackbarOpen}
              handleClose={handleSnackbarClose}
              message={snackbarMessage}
            />
            </TaskListProvider>
          </MaintenanceProvider>
        </SnackbarProvider>
      </AuthProvider>
    </Router>
    </GoogleReCaptchaProvider>
  );
};

export default App;




